function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCharleyWaveFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "0 0 389 423",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M191.8 357.1c-.2-1-.3-2-.5-3-1.3-8.6-2.5-17.2-3.7-25.9-.1-.9-.3-1.7-.6-2.5-1.2-5-5.7-8.8-11.1-8.8-5.6 0-10.2 4-11.3 9.2-.2.6-.4 1.3-.5 2.1-1.2 8.9-2.5 17.9-3.8 26.8l-.3 2.1c-.3 2.1.3 4.3 1.5 6.1.6.1 1.2.3 1.9.4 2.8.5 6.7.8 10.9.8 1.5 0 10.7-.1 16.3-1.7 1-1.7 1.5-3.7 1.2-5.6Z",
    style: {
      fill: "#7c6aad",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191 366.6h-30.3c-2.2 0-4-1.8-4-4V360c0-2.2 1.8-4 4-4 10.2-3.5 20.3-3.6 30.3 0 2.2 0 4 1.8 4 4v2.6c0 2.2-1.8 4-4 4Z",
    style: {
      fill: "#4e436d",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.7 327.1c-1.2 6.6-12 6.6-13.2 0-1.8-14.1-1.5-28.4.7-42.4H182c2.2 14 2.5 28.3.7 42.4ZM233.8 357.1c-.2-1-.3-2-.5-3-1.3-8.6-2.5-17.2-3.7-25.9-.1-.9-.3-1.7-.6-2.5-1.2-5-5.7-8.8-11.1-8.8-5.6 0-10.2 4-11.3 9.2-.2.6-.4 1.3-.5 2.1-1.2 8.9-2.5 17.9-3.8 26.8l-.3 2.1c-.3 2.1.3 4.3 1.5 6.1.6.1 1.2.3 1.9.4 2.8.5 6.7.8 10.9.8 1.5 0 10.7-.1 16.3-1.7 1.1-1.7 1.5-3.7 1.2-5.6Z",
    style: {
      fill: "#7c6aad",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.1 366.6h-30.3c-2.2 0-4-1.8-4-4V360c0-2.2 1.8-4 4-4 10.2-3.5 20.3-3.6 30.3 0 2.2 0 4 1.8 4 4v2.6c0 2.2-1.8 4-4 4Z",
    style: {
      fill: "#4e436d",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.8 327.1c-1.2 6.6-12 6.6-13.2 0-1.8-14.1-1.5-28.4.7-42.4h11.8c2.2 14 2.4 28.3.7 42.4ZM263.115 193.765c9.253-2.877 15.044 10.842 6.555 15.552-3.171 2.331-30.431 14.675-38.836 16.075-10.954 2.03-14.374-10.844-6.555-15.552 12.645-6.327 25.426-12.251 38.836-16.075Zm-37.272 15.401c.626-.135 1.207-.181 1.878-.182-.671.001-1.342.002-1.878.182Zm8.102 4.369Zm0 0Zm0 0Zm0 0Zm0 0Zm0 0Zm0 0Zm.089.045Zm0 0Zm0 0Zm0 0Zm0 0Zm0 0Zm-.045.09Zm0 0Zm0 0Zm.09.044Zm0 0Zm0 0Z",
    style: {
      fill: "#7c6aad",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.013 165.245c.199-.347.262-.657.461-1.004 1.15-3.606-1.048-7.407-4.819-7.267-.583.01-1.03-.015-1.526.045-4.551-.308-7.97-2.388-10.428-6.338-1.965-3.205-6.182-3.092-8.669-.369-.237.21-.436.557-.635.904-.249.434-.548.954-.711 1.437l-.225.793-12.716 41.596c-2.308 5.824 5.185 10.245 9.204 5.058l28.296-32.18 1.107-1.325c.163-.483.412-.917.661-1.35Z",
    style: {
      fill: "#7c6aad",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.242 209.635c-6.748-3.878-9.078-12.504-5.2-19.251 3.877-6.747 12.503-9.077 19.25-5.2 6.748 3.878 9.078 12.503 5.2 19.251-3.877 6.747-12.503 9.077-19.25 5.2Z",
    style: {
      fill: "#4e436d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.745 196.172c-.174-.099-.484-.162-.707-.175-.806-.002-1.515.629-1.603 1.385-.143 2.456-2.219 4.262-4.587 4.169-1.117-.065-2.207-.576-3.098-1.434-.754-.895-1.186-1.95-1.158-3.203.002-.806-.629-1.515-1.385-1.603-.806-.002-1.515.629-1.604 1.385-.116 2.009.537 3.884 1.885 5.351 1.348 1.467 3.132 2.376 5.141 2.493 4.068.146 7.561-2.921 7.757-7.076.163-.483-.208-1.042-.641-1.292Z",
    style: {
      fill: "#7c6aad",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.013 165.245c.199-.347.262-.657.461-1.004-4.973.025-9.969-1.115-14.565-3.756-4.558-2.504-8.245-6.123-10.828-10.259-.236.21-.435.557-.634.903 2.669 4.187 6.356 7.805 10.914 10.31 4.646 2.554 9.678 3.831 14.652 3.806ZM323.168 138.208l-.954-.549c-1.858-1.182-4.352-.655-5.535 1.203l-6.761 10.762c-1.183 1.857-.656 4.352 1.202 5.535l.954.548c1.857 1.183 4.352.655 5.534-1.202l6.762-10.763c1.183-1.857.655-4.352-1.202-5.534Z",
    style: {
      fill: "#4e436d",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m311.541 155.63-.78-.449c-.05.087-.1.174-.15.26-2.404 4.385-8.052 5.984-12.437 3.579-4.385-2.404-5.983-8.052-3.579-12.437.05-.086.1-.173.15-.26l-.954-.548c-1.908-1.096-2.621-3.467-1.612-5.424l11.711-21.182c1.096-1.907 3.467-2.621 5.424-1.611l.434.249c.607.349.978.908.939 1.577.048.72.828 1.168 1.387.798.646-.321 1.365-.369 1.972-.02l.954.548c.607.349 1.014 1.044 1.062 1.764.048.719.829 1.168 1.388.797.695-.408 1.501-.406 2.195-.007l1.04.598c.694.398 1.188 1.144 1.186 1.95.048.719.829 1.168 1.388.797.695-.407 1.638-.442 2.332-.044l1.3.748c1.908 1.096 2.621 3.467 1.612 5.424l-11.711 21.181c-.836 2.057-3.294 2.721-5.251 1.712ZM122.6 309.5h-1.1c-2.2.1-4.1-1.6-4.2-3.8l-.5-12.7c-.1-2.2 1.6-4.1 3.8-4.2h1.1c2.2-.1 4.1 1.6 4.2 3.8l.5 12.7c.1 2.2-1.6 4.1-3.8 4.2Z",
    style: {
      fill: "#4e436d",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.2 288.8h-.9v-.3c.1-5-4-9.2-9-9.3-5-.1-9.2 4-9.3 9v.3h-1.1c-2.2 0-4 1.7-4.1 3.9l-.4 24.2c0 2.2 1.7 4 3.9 4.1h.5c.7 0 1.3-.3 1.6-.9.4-.6 1.3-.6 1.6 0 .4.6 1 1 1.7 1h1.1c.7 0 1.4-.4 1.8-1 .4-.6 1.3-.6 1.6 0 .4.7 1.1 1.1 1.9 1.1h1.2c.8 0 1.6-.4 2-1.1.4-.6 1.3-.6 1.6 0 .4.7 1.2 1.2 2 1.2h1.5c2.2 0 4-1.7 4.1-3.9l.4-24.2c.3-2.2-1.5-4-3.7-4.1Z",
    style: {
      fill: "#4e436d",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.4 280.5c0 .4-.1.7-.1 1.1-.8 3.7-4.6 5.9-7.8 3.9-.5-.3-.9-.5-1.3-.8-4.1-2-8.1-1.9-12.2.3-3.3 1.8-6.9-.4-7.7-4-.1-.3-.1-.7-.1-1.1 0-.5 0-1.1.1-1.6l.2-.8 9.7-42.4c.9-6.2 9.6-6.3 10.5.2l8.5 42 .3 1.7c-.1.5-.1 1-.1 1.5Z",
    style: {
      fill: "#7c6aad",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.2 198.2c7.7-4.9 17.8 3.9 11 12.8-5 6.9-28.2 25.8-31.7 27.6-8 5.6-17.7-5.7-11-12.8 9.5-10.3 20.6-19.1 31.7-27.6Zm-2.2 2.7c.2-.6.6-1.1 1-1.6-.4.4-.7 1-1 1.6Zm1.3 7.6Zm0 0Zm0 0Zm0 0Zm0 0Zm0 0Zm0 0Zm0 .1Zm0 0Zm0 0Zm0 0Zm0 0Zm.1 0Zm0 0Zm0 0Zm0 0Zm0 .1Zm0 0Zm0 0Z",
    style: {
      fill: "#7c6aad",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.3,
    cy: 235.3,
    r: 14.1,
    style: {
      fill: "#4e436d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.3 239.6c-.2 0-.5-.1-.7-.2-.7-.4-1-1.3-.7-2 1.1-2.2.2-4.8-1.9-5.9-1-.5-2.2-.6-3.4-.3-1.1.4-2 1.1-2.6 2.2-.4.7-1.3 1-2 .7-.7-.4-1-1.3-.7-2 .9-1.8 2.4-3.1 4.3-3.7 1.9-.6 3.9-.5 5.7.4 3.6 1.9 5.1 6.3 3.2 10-.1.5-.6.8-1.2.8Z",
    style: {
      fill: "#7c6aad",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.8 276.5c-5.3-.1-10.3 1.2-14.6 3.5 0 .4 0 .7.1 1.1 4.3-2.3 9.3-3.6 14.5-3.5 5.3.1 10.2 1.5 14.5 4 .1-.3.1-.7.1-1.1-4.3-2.5-9.3-3.9-14.6-4Z",
    style: {
      fill: "#4e436d",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.7 296.5h-66.5c-9.9 0-18-8.1-18-18V195h102.5v83.5c0 9.9-8.1 18-18 18Z",
    style: {
      fill: "#a696c8",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.7 279h-64.1c-2.8 0-5-2.2-5-5v-56.4c0-2.8 2.2-5 5-5h64.1c2.8 0 5 2.2 5 5V274c0 2.8-2.2 5-5 5Z",
    style: {
      fill: "#2b333f",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.7 279.5h-64.1c-3 0-5.5-2.5-5.5-5.5v-56.4c0-3 2.5-5.5 5.5-5.5h64.1c3 0 5.5 2.5 5.5 5.5V274c0 3-2.4 5.5-5.5 5.5Zm-64-66.4c-2.5 0-4.5 2-4.5 4.5V274c0 2.5 2 4.5 4.5 4.5h64.1c2.5 0 4.5-2 4.5-4.5v-56.4c0-2.5-2-4.5-4.5-4.5h-64.1Z",
    style: {
      fill: "#7c6aad",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233 208.3h5.7v5.7H233z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.9,
    cy: 211.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 214h5.7v5.7H233z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.9,
    cy: 216.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 219.7h5.7v5.7H233z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.9,
    cy: 222.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 225.3h5.7v5.7H233z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.9,
    cy: 228.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 231h5.7v5.7H233z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.9,
    cy: 233.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 236.7h5.7v5.7H233z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.9,
    cy: 239.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 242.3h5.7v5.7H233z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.9,
    cy: 245.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 248h5.7v5.7H233z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.9,
    cy: 250.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 253.7h5.7v5.7H233z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.9,
    cy: 256.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 259.3h5.7v5.7H233z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.9,
    cy: 262.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 265h5.7v5.7H233z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.9,
    cy: 267.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 270.7h5.7v5.7H233z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.9,
    cy: 273.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 276.3h5.7v5.7H233z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.9,
    cy: 279.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.4 208.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.2,
    cy: 211.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.4 214h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.2,
    cy: 216.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.4 219.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.2,
    cy: 222.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.4 225.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.2,
    cy: 228.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.4 231h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.2,
    cy: 233.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.4 236.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.2,
    cy: 239.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.4 242.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.2,
    cy: 245.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.4 248h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.2,
    cy: 250.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.4 253.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.2,
    cy: 256.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.4 259.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.2,
    cy: 262.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.4 265h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.2,
    cy: 267.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.4 270.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.2,
    cy: 273.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.4 276.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.2,
    cy: 279.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.7 208.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.5,
    cy: 211.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.7 214h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.5,
    cy: 216.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.7 219.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.5,
    cy: 222.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.7 225.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.5,
    cy: 228.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.7 231h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.5,
    cy: 233.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.7 236.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.5,
    cy: 239.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.7 242.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.5,
    cy: 245.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.7 248h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.5,
    cy: 250.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.7 253.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.5,
    cy: 256.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.7 259.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.5,
    cy: 262.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.7 265h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.5,
    cy: 267.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.7 270.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.5,
    cy: 273.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.7 276.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.5,
    cy: 279.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 208.3h5.7v5.7H216z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.9,
    cy: 211.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 214h5.7v5.7H216z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.9,
    cy: 216.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 219.7h5.7v5.7H216z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.9,
    cy: 222.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 225.3h5.7v5.7H216z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.9,
    cy: 228.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 231h5.7v5.7H216z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.9,
    cy: 233.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 236.7h5.7v5.7H216z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.9,
    cy: 239.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 242.3h5.7v5.7H216z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.9,
    cy: 245.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 248h5.7v5.7H216z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.9,
    cy: 250.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 253.7h5.7v5.7H216z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.9,
    cy: 256.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 259.3h5.7v5.7H216z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.9,
    cy: 262.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 265h5.7v5.7H216z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.9,
    cy: 267.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 270.7h5.7v5.7H216z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.9,
    cy: 273.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 276.3h5.7v5.7H216z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.9,
    cy: 279.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.4 208.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.2,
    cy: 211.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.4 214h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.2,
    cy: 216.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.4 219.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.2,
    cy: 222.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.4 225.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.2,
    cy: 228.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.4 231h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.2,
    cy: 233.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.4 236.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.2,
    cy: 239.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.4 242.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.2,
    cy: 245.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.4 248h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.2,
    cy: 250.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.4 253.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.2,
    cy: 256.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.4 259.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.2,
    cy: 262.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.4 265h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.2,
    cy: 267.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.4 270.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.2,
    cy: 273.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.4 276.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.2,
    cy: 279.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.7 208.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 211.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.7 214h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 216.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.7 219.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 222.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.7 225.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 228.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.7 231h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 233.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.7 236.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 239.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.7 242.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 245.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.7 248h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 250.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.7 253.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 256.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.7 259.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 262.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.7 265h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 267.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.7 270.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 273.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.7 276.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 279.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199 208.3h5.7v5.7H199z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.9,
    cy: 211.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199 214h5.7v5.7H199z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.9,
    cy: 216.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199 219.7h5.7v5.7H199z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.9,
    cy: 222.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199 225.3h5.7v5.7H199z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.9,
    cy: 228.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199 231h5.7v5.7H199z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.9,
    cy: 233.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199 236.7h5.7v5.7H199z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.9,
    cy: 239.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199 242.3h5.7v5.7H199z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.9,
    cy: 245.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199 248h5.7v5.7H199z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.9,
    cy: 250.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199 253.7h5.7v5.7H199z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.9,
    cy: 256.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199 259.3h5.7v5.7H199z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.9,
    cy: 262.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199 265h5.7v5.7H199z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.9,
    cy: 267.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199 270.7h5.7v5.7H199z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.9,
    cy: 273.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199 276.3h5.7v5.7H199z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.9,
    cy: 279.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.4 208.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.2,
    cy: 211.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.4 214h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.2,
    cy: 216.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.4 219.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.2,
    cy: 222.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.4 225.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.2,
    cy: 228.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.4 231h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.2,
    cy: 233.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.4 236.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.2,
    cy: 239.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.4 242.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.2,
    cy: 245.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.4 248h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.2,
    cy: 250.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.4 253.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.2,
    cy: 256.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.4 259.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.2,
    cy: 262.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.4 265h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.2,
    cy: 267.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.4 270.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.2,
    cy: 273.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.4 276.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.2,
    cy: 279.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.7 208.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.5,
    cy: 211.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.7 214h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.5,
    cy: 216.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.7 219.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.5,
    cy: 222.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.7 225.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.5,
    cy: 228.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.7 231h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.5,
    cy: 233.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.7 236.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.5,
    cy: 239.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.7 242.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.5,
    cy: 245.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.7 248h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.5,
    cy: 250.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.7 253.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.5,
    cy: 256.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.7 259.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.5,
    cy: 262.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.7 265h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.5,
    cy: 267.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.7 270.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.5,
    cy: 273.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.7 276.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.5,
    cy: 279.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 208.3h5.7v5.7H182z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.9,
    cy: 211.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 214h5.7v5.7H182z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.9,
    cy: 216.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 219.7h5.7v5.7H182z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.9,
    cy: 222.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 225.3h5.7v5.7H182z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.9,
    cy: 228.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 231h5.7v5.7H182z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.9,
    cy: 233.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 236.7h5.7v5.7H182z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.9,
    cy: 239.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 242.3h5.7v5.7H182z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.9,
    cy: 245.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 248h5.7v5.7H182z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.9,
    cy: 250.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 253.7h5.7v5.7H182z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.9,
    cy: 256.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 259.3h5.7v5.7H182z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.9,
    cy: 262.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 265h5.7v5.7H182z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.9,
    cy: 267.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 270.7h5.7v5.7H182z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.9,
    cy: 273.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 276.3h5.7v5.7H182z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.9,
    cy: 279.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.3 208.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.2,
    cy: 211.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.3 214h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.2,
    cy: 216.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.3 219.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.2,
    cy: 222.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.3 225.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.2,
    cy: 228.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.3 231h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.2,
    cy: 233.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.3 236.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.2,
    cy: 239.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.3 242.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.2,
    cy: 245.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.3 248h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.2,
    cy: 250.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.3 253.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.2,
    cy: 256.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.3 259.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.2,
    cy: 262.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.3 265h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.2,
    cy: 267.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.3 270.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.2,
    cy: 273.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.3 276.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.2,
    cy: 279.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.7 208.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.5,
    cy: 211.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.7 214h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.5,
    cy: 216.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.7 219.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.5,
    cy: 222.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.7 225.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.5,
    cy: 228.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.7 231h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.5,
    cy: 233.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.7 236.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.5,
    cy: 239.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.7 242.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.5,
    cy: 245.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.7 248h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.5,
    cy: 250.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.7 253.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.5,
    cy: 256.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.7 259.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.5,
    cy: 262.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.7 265h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.5,
    cy: 267.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.7 270.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.5,
    cy: 273.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.7 276.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.5,
    cy: 279.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 208.3h5.7v5.7H165z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.8,
    cy: 211.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 214h5.7v5.7H165z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.8,
    cy: 216.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 219.7h5.7v5.7H165z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.8,
    cy: 222.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 225.3h5.7v5.7H165z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.8,
    cy: 228.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 231h5.7v5.7H165z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.8,
    cy: 233.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 236.7h5.7v5.7H165z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.8,
    cy: 239.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 242.3h5.7v5.7H165z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.8,
    cy: 245.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 248h5.7v5.7H165z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.8,
    cy: 250.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 253.7h5.7v5.7H165z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.8,
    cy: 256.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 259.3h5.7v5.7H165z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.8,
    cy: 262.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 265h5.7v5.7H165z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.8,
    cy: 267.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 270.7h5.7v5.7H165z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.8,
    cy: 273.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 276.3h5.7v5.7H165z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.8,
    cy: 279.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.3 208.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.2,
    cy: 211.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.3 214h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.2,
    cy: 216.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.3 219.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.2,
    cy: 222.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.3 225.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.2,
    cy: 228.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.3 231h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.2,
    cy: 233.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.3 236.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.2,
    cy: 239.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.3 242.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.2,
    cy: 245.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.3 248h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.2,
    cy: 250.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.3 253.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.2,
    cy: 256.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.3 259.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.2,
    cy: 262.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.3 265h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.2,
    cy: 267.8,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.3 270.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.2,
    cy: 273.5,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.3 276.3h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.2,
    cy: 279.2,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M216 231h5.7v5.7H216z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.9,
    cy: 233.9,
    r: 1.2,
    style: {
      fill: "#eb5786"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 236.7h5.7v5.7H216z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.9,
    cy: 239.5,
    r: 1.2,
    style: {
      fill: "#eb5786"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 242.4h5.7v5.7H216z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.9,
    cy: 245.2,
    r: 1.2,
    style: {
      fill: "#eb5786"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.3 225.4h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.3 231h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.2,
    cy: 233.9,
    r: 1.2,
    style: {
      fill: "#eb5786"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.6 227.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.4,
    cy: 230.5,
    r: 1.2,
    style: {
      fill: "#eb5786"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.8 227.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.7,
    cy: 230.5,
    r: 1.2,
    style: {
      fill: "#eb5786"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.3 236.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.2,
    cy: 239.5,
    r: 1.2,
    style: {
      fill: "#eb5786"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.3 242.4h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.2,
    cy: 245.2,
    r: 1.2,
    style: {
      fill: "#eb5786"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.3 248h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.2,
    cy: 250.9,
    r: 1.2,
    style: {
      fill: "#eb5786"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.7 225.4h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.7 231h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 233.9,
    r: 1.2,
    style: {
      fill: "#eb5786"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.7 236.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 239.5,
    r: 1.2,
    style: {
      fill: "#eb5786"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.7 242.4h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 245.2,
    r: 1.2,
    style: {
      fill: "#eb5786"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.7 248h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 250.9,
    r: 1.2,
    style: {
      fill: "#eb5786"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.7 253.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 256.6,
    r: 1.2,
    style: {
      fill: "#eb5786"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199 231h5.7v5.7H199z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.8,
    cy: 233.9,
    r: 1.2,
    style: {
      fill: "#eb5786"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199 236.7h5.7v5.7H199z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.8,
    cy: 239.5,
    r: 1.2,
    style: {
      fill: "#eb5786"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199 242.4h5.7v5.7H199z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.8,
    cy: 245.2,
    r: 1.2,
    style: {
      fill: "#eb5786"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199 248h5.7v5.7H199z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.8,
    cy: 250.9,
    r: 1.2,
    style: {
      fill: "#eb5786"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199 253.7h5.7v5.7H199z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.8,
    cy: 256.6,
    r: 1.2,
    style: {
      fill: "#eb5786"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199 259.4h5.7v5.7H199z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.8,
    cy: 262.2,
    r: 1.2,
    style: {
      fill: "#eb5786"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.3 231h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.2,
    cy: 233.9,
    r: 1.2,
    style: {
      fill: "#eb5786"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.3 236.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.2,
    cy: 239.5,
    r: 1.2,
    style: {
      fill: "#eb5786"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.3 242.4h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.2,
    cy: 245.2,
    r: 1.2,
    style: {
      fill: "#eb5786"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.3 248h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.2,
    cy: 250.9,
    r: 1.2,
    style: {
      fill: "#eb5786"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.3 253.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.2,
    cy: 256.6,
    r: 1.2,
    style: {
      fill: "#eb5786"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.3 259.4h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.2,
    cy: 262.2,
    r: 1.2,
    style: {
      fill: "#eb5786"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.7 231h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.5,
    cy: 233.9,
    r: 1.2,
    style: {
      fill: "#eb5786"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.7 236.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.5,
    cy: 239.5,
    r: 1.2,
    style: {
      fill: "#eb5786"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.7 242.4h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.5,
    cy: 245.2,
    r: 1.2,
    style: {
      fill: "#eb5786"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.7 248h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.5,
    cy: 250.9,
    r: 1.2,
    style: {
      fill: "#eb5786"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.7 253.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.5,
    cy: 256.6,
    r: 1.2,
    style: {
      fill: "#eb5786"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 231h5.7v5.7H182z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.8,
    cy: 233.9,
    r: 1.2,
    style: {
      fill: "#eb5786"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 236.7h5.7v5.7H182z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.8,
    cy: 239.5,
    r: 1.2,
    style: {
      fill: "#eb5786"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 242.4h5.7v5.7H182z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.8,
    cy: 245.2,
    r: 1.2,
    style: {
      fill: "#eb5786"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 248h5.7v5.7H182z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.8,
    cy: 250.9,
    r: 1.2,
    style: {
      fill: "#eb5786"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.3 231h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.2,
    cy: 233.9,
    r: 1.2,
    style: {
      fill: "#eb5786"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.3 236.7h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.2,
    cy: 239.5,
    r: 1.2,
    style: {
      fill: "#eb5786"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.3 242.4h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.2,
    cy: 245.2,
    r: 1.2,
    style: {
      fill: "#eb5786"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.3 248h5.7v5.7h-5.7z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 231.3c4.9-4.1 12.3-3.6 16.9.8l1.8 1.7 1.8-1.8c4.4-4.6 11.8-5.5 16.9-1.5 5.8 4.5 6.3 12.8 1.3 17.9L201.5 266c-1.1 1.1-2.9 1.2-4.1.1l-17.9-16.9c-5.2-4.8-5.1-13.1.5-17.9Z",
    style: {
      fill: "#eb5786",
      fillOpacity: 0.35,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.4 197.9c0 6.7-17.4 6.7-17.4 0v-22.4h17.4v22.4Z",
    style: {
      fill: "#7c6aad",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.7 223.9c-2.2 0-4-1.8-4-4v-23.8c0-2.2 1.8-4 4-4s4 1.8 4 4v23.8c.1 2.2-1.7 4-4 4ZM145.2 223.9c-2.2 0-4-1.8-4-4v-23.8c0-2.2 1.8-4 4-4s4 1.8 4 4v23.8c0 2.2-1.8 4-4 4ZM183.5 299.6h-15.2c-1.7 0-3.2-1.4-3.2-3.2 0-1.7 1.4-3.2 3.2-3.2h15.2c1.7 0 3.2 1.4 3.2 3.2-.1 1.8-1.5 3.2-3.2 3.2ZM225.5 299.6h-15.2c-1.7 0-3.2-1.4-3.2-3.2 0-1.7 1.4-3.2 3.2-3.2h15.2c1.7 0 3.2 1.4 3.2 3.2 0 1.8-1.4 3.2-3.2 3.2Z",
    style: {
      fill: "#b7abd4",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.7 183.6c-20.8 2.3-42.1 3.4-63.4 3.4h-.2c-14.9-.2-27.9-12-29.5-27l-7.2-66.5c-1.6-15 8.5-29.3 23-32.7h.2c20.8-4.5 41.9-8 62.7-10.2 20.8-2.3 42.1-3.4 63.4-3.4h.2c14.9.2 27.9 12 29.5 27l7.2 66.5c1.6 15-8.5 29.3-23 32.7h-.2c-20.8 4.5-41.9 7.9-62.7 10.2Z",
    style: {
      fill: "#7c6aad",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.3 159.5c-40.7 8.9-81.4 13.3-123.1 13.3-7.7-.1-14.7-6.7-15.6-14.4-2.4-22.2-4.8-44.4-7.2-66.5-.8-7.7 4.6-15.6 12.1-17.4 40.7-8.9 81.4-13.3 123.1-13.3 7.7.1 14.7 6.7 15.6 14.4 2.4 22.2 4.8 44.4 7.2 66.5.9 7.8-4.6 15.7-12.1 17.4Z",
    style: {
      fill: "#b7abd4",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.6 152c-7.4 0-14.9-1.5-22.6-4.4-1.5-.6-2.3-2.3-1.7-3.9.6-1.5 2.3-2.3 3.9-1.7 17.8 6.8 34.2 5.1 50.1-5.4 1.4-.9 3.2-.5 4.2.9.9 1.4.5 3.2-.9 4.2-10.6 6.9-21.6 10.3-33 10.3Z",
    style: {
      fill: "#4e436d",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.289 87.819c6.255-.678 12.28 7.503 13.445 18.258 1.165 10.755-2.968 20.037-9.223 20.714-6.256.678-12.28-7.503-13.445-18.258-1.165-10.755 2.967-20.037 9.223-20.714ZM211.496 82.223c6.256-.677 12.28 7.504 13.445 18.259 1.165 10.755-2.967 20.036-9.223 20.714-6.255.678-12.279-7.504-13.444-18.259-1.166-10.754 2.967-20.036 9.222-20.714Z",
    style: {
      fill: "#4e436d"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharleyWaveFull);
export default __webpack_public_path__ + "static/media/charley_wave_full.a938ca0faf88040a00b85bd49ebc83d9.svg";
export { ForwardRef as ReactComponent };